export enum ParserDocument {
  "Анкета физического лица" = "Анкета физического лица",
  "Согласие на обработку персональных данных" = "Согласие на обработку персональных данных",
  "Декларация о рисках" = "Декларация о рисках",
  "Брокерский договор" = "Брокерский договор",
  "Участник: Анкета Бенефициарного владельца" = "Участник: Анкета Бенефициарного владельца",
  "Участник: согласие на обработку персональных данных" = "Участник: согласие на обработку персональных данных",
  "Юр лицо: Анкета юридического лица" = "Юр лицо: Анкета юридического лица",
  "Юр лицо: Анкета бенефициарного владельца" = "Юр лицо: Анкета бенефициарного владельца",
  "Юр лицо: Брокерский договор" = "Юр лицо: Брокерский договор",
  "Юр лицо: Декларация о рисках" = "Юр лицо: Декларация о рисках",
  "Юр лицо: Карточка образцов подписей" = "Юр лицо: Карточка образцов подписей",
}

export enum ParserFieldName {
  "_Фамилия_" = "_Фамилия_",
  "_Имя_" = "_Имя_",
  "_Отчество_" = "_Отчество_",
  "_ДатаРождения_" = "_ДатаРождения_",
  "_Гражданство_" = "_Гражданство_",
  "_Серия/Номер_" = "_Серия/Номер_",
  "_ДатаВыдачиПаспорт_" = "_ДатаВыдачиПаспорт_",
  "_НаименованиеОрганаВыдавшего_" = "_НаименованиеОрганаВыдавшего_",
  "_АдресФизЛицо_" = "_АдресФизЛицо_",
  "_ТекущаяДАТА_" = "_ТекущаяДАТА_",
  "_email_" = "_email_",
  "_НомерДоговор_" = "_НомерДоговор_",
  "_Наименование_" = "_Наименование_",
  "_ОПФ_" = "_ОПФ_",
  "_ИНН_" = "_ИНН_",
  "_НомерТелефона_" = "_НомерТелефона_",
  "_ДатаРег_" = "_ДатаРег_",
  "_РегНомер_" = "_РегНомер_",
  "_ЮрАдрес_" = "_ЮрАдрес_",
  "_телефон_" = "_телефон_",
  "_Капитал_" = "_Капитал_",
  "_ВалютаКапитал_" = "_ВалютаКапитал_",
  "_виддеят_" = "_виддеят_",
  "_ФамилияДир_" = "_ФамилияДир_",
  "_ИмяДир_" = "_ИмяДир_",
  "_ОтчествоДир_" = "_ОтчествоДир_",
  "_ФамилияДол_" = "_ФамилияДол_",
  "_ИмяДол_" = "_ИмяДол_",
  "_ОтчествоДол_" = "_ОтчествоДол_",
  "_ФамилияБен_" = "_ФамилияБен_",
  "_ИмяБен_" = "_ИмяБен_",
  "_ОтчествоБен_" = "_ОтчествоБен_",
  "_доля_" = "_доля_",
}

export enum ParserFieldKey {
  "_Фамилия_" = "sur_name",
  "_Имя_" = "name",
  "_Отчество_" = "patronymic",
  "_ДатаРождения_" = "birth_date",
  "_Гражданство_" = "citizenship",
  "_Серия/Номер_" = "passport",
  "_ДатаВыдачиПаспорт_" = "passport_date",
  "_НаименованиеОрганаВыдавшего_" = "passport_issued_org",
  "_АдресФизЛицо_" = "address",
  "_ТекущаяДАТА_" = "date",
  "_email_" = "email",
  "_НомерДоговор_" = "numberAgreement",
  "_Наименование_" = "companyName",
  "_ОПФ_" = "opf",
  "_ИНН_" = "inn",
  "_НомерТелефона_" = "phone",
  "_ДатаРег_" = "dateRegistration",
  "_РегНомер_" = "numberRegistration",
  "_ЮрАдрес_" = "legalAddress",
  "_телефон_" = "phone",
  "_Капитал_" = "capital",
  "_ВалютаКапитал_" = "capital_currency",
  "_виддеят_" = "business_area",
  "_ФамилияДир_" = "director_sur_name",
  "_ИмяДир_" = "director_name",
  "_ОтчествоДир_" = "director_patronymic",
  "_ФамилияДол_" = "officer_sur_name",
  "_ИмяДол_" = "officer_name",
  "_ОтчествоДол_" = "officer_patronymic",
  "_ФамилияБен_" = "beneficiary_sur_name",
  "_ИмяБен_" = "beneficiary_name",
  "_ОтчествоБен_" = "beneficiary_patronymic",
  "_доля_" = "share_in_org",
}
